import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import JobsBoardBannerAd from 'components/Ads/JobsBoardBanner/JobsBoardBannerAd';

const JobsBoardBanner = ({ partners, loadedPartners }) => {
  const advert = useMemo(() => {
    if (!loadedPartners || !partners || partners.length === 0) {
      return null;
    }

    const randomNumber = Math.floor(Math.random() * partners.length);
    return partners[randomNumber];
  }, [loadedPartners, partners]);

  // Location exclusions can return an empty list. Drop the reserved slot then.
  if (loadedPartners && (!partners || partners.length === 0)) {
    return null;
  }

  return <JobsBoardBannerAd advert={advert} />;
};

JobsBoardBanner.propTypes = {
  partners: PropTypes.array,
  loadedPartners: PropTypes.bool,
  loadingPartners: PropTypes.bool,
};

export default React.memo(JobsBoardBanner);
